import { render, staticRenderFns } from "./Birth.vue?vue&type=template&id=7cf2bd2a&scoped=true"
import script from "./Birth.vue?vue&type=script&lang=js"
export * from "./Birth.vue?vue&type=script&lang=js"
import style0 from "./Birth.vue?vue&type=style&index=0&id=7cf2bd2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf2bd2a",
  null
  
)

export default component.exports